import React, { useState } from 'react';
import styled from 'styled-components';
import { useLocation } from 'wouter';

const investOptions = [
  { label: 'Acciones', icon: 'grid', route: '/Acciones' },
  { label: 'Crowdfunding', icon: 'people' },
  { label: 'Crypto', icon: 'coin' },
  { label: 'Divisas', icon: 'dollar' },
];

const userOptions = [
  { label: 'Mi perfil', icon: 'user' },
  { label: 'Mi portafolio', icon: 'folder' },
  { label: 'Mi información', icon: 'info' },
  { label: 'Mi historial', icon: 'clock' },
  { label: 'Notificaciones', icon: 'bell' },
  { label: 'Cerrar sesión', icon: 'logout', danger: true },
];

const Icon = ({ name }) => {
  const common = {
    width: 18,
    height: 18,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  };
  switch (name) {
    case 'grid':
      return (
        <svg {...common}>
          <rect x="3" y="3" width="7" height="7" rx="1" />
          <rect x="14" y="3" width="7" height="7" rx="1" />
          <rect x="3" y="14" width="7" height="7" rx="1" />
          <rect x="14" y="14" width="7" height="7" rx="1" />
        </svg>
      );
    case 'people':
      return (
        <svg {...common}>
          <circle cx="9" cy="8" r="3" />
          <path d="M3 20c0-3 3-5 6-5s6 2 6 5" />
          <circle cx="17" cy="9" r="2.4" />
          <path d="M15 20c0-2 1.5-3.5 4-4" />
        </svg>
      );
    case 'coin':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M10 8h2.5a2 2 0 010 4H10m0 0h2.5a2 2 0 010 4H10m0-8v8M12 6v1M12 17v1" />
        </svg>
      );
    case 'dollar':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v10M15 9.5c0-1.4-1.3-2.5-3-2.5s-3 1-3 2.3 1.3 2 3 2.2c1.8.2 3 1 3 2.3S13.6 16 12 16s-3-1-3-2.5" />
        </svg>
      );
    case 'user':
      return (
        <svg {...common}>
          <circle cx="12" cy="8" r="3.5" />
          <path d="M4.5 20c0-4 3.5-6.5 7.5-6.5s7.5 2.5 7.5 6.5" />
        </svg>
      );
    case 'folder':
      return (
        <svg {...common}>
          <path d="M3 7a1 1 0 011-1h5l2 2h9a1 1 0 011 1v9a1 1 0 01-1 1H4a1 1 0 01-1-1V7z" />
        </svg>
      );
    case 'info':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 11v5M12 8v.5" />
        </svg>
      );
    case 'clock':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
      );
    case 'bell':
      return (
        <svg {...common}>
          <path d="M6 10a6 6 0 0112 0c0 4 1.5 5.5 1.5 5.5H4.5S6 14 6 10z" />
          <path d="M10 19a2 2 0 004 0" />
        </svg>
      );
    case 'logout':
      return (
        <svg {...common}>
          <path d="M15 4h3a2 2 0 012 2v12a2 2 0 01-2 2h-3" />
          <path d="M10 8l-4 4 4 4M4 12h13" />
        </svg>
      );
    default:
      return null;
  }
};

export const Navbar = () => {
  const [, setLocation] = useLocation();
  const [isInvestOpen, setIsInvestOpen] = useState(false);
  const [isUserOpen, setIsUserOpen] = useState(false);

  const handleInvestOptionClick = (option) => {
    if (option.route) {
      setLocation(option.route);
    }
    setIsInvestOpen(false);
  };

  return (
    <NavbarContainer>
      <BrandLink href="/">
        AKAD
        <BrandOrange>E</BrandOrange>
        MIA
      </BrandLink>

      <RightGroup>
        <NavItems>
          <NavDropdownWrap>
            <InvestButton
              type="button"
              onClick={() => {
                setIsInvestOpen(!isInvestOpen);
                setIsUserOpen(false);
              }}
            >
              Invertir
              <Chevron open={isInvestOpen}>›</Chevron>
            </InvestButton>

            {isInvestOpen && (
              <InvestMenu>
                {investOptions.map((option) => (
                  <MenuItem
                    key={option.label}
                    type="button"
                    onClick={() => handleInvestOptionClick(option)}
                  >
                    <MenuIcon>
                      <Icon name={option.icon} />
                    </MenuIcon>
                    {option.label}
                  </MenuItem>
                ))}
              </InvestMenu>
            )}
          </NavDropdownWrap>

          <NavLink href="/guias">Guías</NavLink>
          <NavLink href="/acerca-de-nosotros">Acerca de nosotros</NavLink>
        </NavItems>

        <Divider />

        <UserDropdownWrap>
          <UserButton
            type="button"
            onClick={() => {
              setIsUserOpen(!isUserOpen);
              setIsInvestOpen(false);
            }}
          >
            <Avatar>N</Avatar>
            <UserName>Nicolas Rubiano</UserName>
            <UserChevron open={isUserOpen}>›</UserChevron>
          </UserButton>

          {isUserOpen && (
            <UserMenu>
              {userOptions.map((option) => (
                <UserMenuItem key={option.label} type="button" $danger={option.danger}>
                  <MenuIcon>
                    <Icon name={option.icon} />
                  </MenuIcon>
                  {option.label}
                </UserMenuItem>
              ))}
            </UserMenu>
          )}
        </UserDropdownWrap>
      </RightGroup>
    </NavbarContainer>
  );
};

const NavbarContainer = styled.div`
  width: 100%;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 48px;
  background: #ffffff;
  border-bottom: 1px solid #efefef;
  font-family: 'Montserrat', sans-serif;
  position: relative;
`;

const BrandLink = styled.a`
  font-size: 26px;
  font-weight: 700;
  color: #0C447C;
  text-decoration: none;
`;

const BrandOrange = styled.span`
  color: #FF751F;
`;

const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
`;

const NavItems = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
`;

const NavDropdownWrap = styled.div`
  position: relative;
`;

const InvestButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #FF751F;
  color: #ffffff;
  border: none;
  border-radius: 24px;
  padding: 10px 22px;
  font-size: 15px;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  cursor: pointer;
`;

const Chevron = styled.span`
  font-size: 16px;
  line-height: 1;
  display: inline-flex;
  transform: ${({ open }) => (open ? 'rotate(90deg)' : 'rotate(0deg)')};
  transition: transform 0.15s ease;
`;

const NavLink = styled.a`
  font-size: 16px;
  font-weight: 500;
  color: #4a4a4a;
  text-decoration: none;
`;

const Divider = styled.div`
  width: 1px;
  height: 32px;
  background: #d0d0d0;
`;

const UserDropdownWrap = styled.div`
  position: relative;
`;

const UserButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
`;

const Avatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #0C447C;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 700;
`;

const UserChevron = styled.span`
  font-size: 18px;
  color: #FF751F;
  transform: ${({ open }) => (open ? 'rotate(90deg)' : 'rotate(0deg)')};
  transition: transform 0.15s ease;
`;

const UserName = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #0C447C;
`;

const InvestMenu = styled.div`
  position: absolute;
  top: calc(100% + 12px);
  left: 0;
  background: #e5e5e5;
  border-radius: 16px;
  padding: 12px;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 20;
`;

const MenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  background: none;
  border: none;
  text-align: left;
  padding: 10px 12px;
  font-size: 16px;
  color: #3a3a3a;
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;
`;

const MenuIcon = styled.span`
  display: flex;
  color: #FF751F;
`;

const UserMenu = styled.div`
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  background: #e5e5e5;
  border-radius: 16px;
  padding: 12px;
  min-width: 220px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 20;
`;

const UserMenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  background: none;
  border: none;
  text-align: left;
  padding: 10px 12px;
  font-size: 16px;
  color: ${({ $danger }) => ($danger ? '#e2504a' : '#3a3a3a')};
  cursor: pointer;
  font-family: 'Montserrat', sans-serif;

  ${MenuIcon} {
    color: ${({ $danger }) => ($danger ? '#e2504a' : '#FF751F')};
  }
`;
